import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListColumns = createSelector([
  getProjectListState,
], (state) => state.columns);
